import { feedbackUrls } from '@/configs/endpoints'
import api from '@/plugins/api'

export default {
  state: () => ({
    isReady: false
  }),
  mutations: {
    SET_IS_READY(state, value) {
      state.isReady = value
    }
  },
  actions: {
    async getFeedbackStatus({ commit }) {
      const response = await api.get(feedbackUrls.index)
      commit('SET_IS_READY', !!response.data?.is_ready)
    },
    sendFeedback(_, data) {
      return api.post(feedbackUrls.index, { body: { platform: 'web', ...data } })
    },
    dismissFeedback({ commit }) {
      commit('SET_IS_READY', false)
    }
  }
}
